import { NotSelected } from './not-selected';
import { ActualValue } from './actual-value';
import { Interval } from './interval';
import { Period } from './period';
import { AggregateValue } from './aggregate-value';
import { AggregateCategory } from './aggregate-category';
import { SelectionType } from '../../types-fields';

export const selectionTypeConfiguration = {
  [SelectionType.NotSelected]: NotSelected,
  [SelectionType.ActualValue]: ActualValue,
  [SelectionType.Interval]: Interval,
  [SelectionType.Period]: Period,
  [SelectionType.AggregateValue]: AggregateValue,
  [SelectionType.AggregateCategory]: AggregateCategory
};
